import loadable from '@loadable/component';

export const productBoxTypes = {
	regular: loadable(() => import('/views/partials/eventbox/types/regular')),
	horizontal: loadable(() => import('/views/partials/eventbox/types/horizontal')),
};

export default productBoxTypes;
